import React, { memo, ReactNode } from "react";
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from "@chakra-ui/react";

import { RelatedMessageThreadFragment } from "gql/graphql";
import RelatedMessageThreadList from "./related-message-thread-list";

interface IProps {
  relatedMessageThreads: Array<RelatedMessageThreadFragment>;
  children: ReactNode;
}

const LinkedConversationsPopover = ({
  relatedMessageThreads,
  children,
}: IProps) => (
  <Popover trigger="hover" placement="bottom-start" isLazy>
    <PopoverTrigger>{children}</PopoverTrigger>
    <Portal>
      <PopoverContent w="fit-content" minW={400} maxW={800}>
        <PopoverArrow />
        <PopoverBody p={4}>
          <RelatedMessageThreadList
            relatedMessageThreads={relatedMessageThreads}
          />
        </PopoverBody>
      </PopoverContent>
    </Portal>
  </Popover>
);

export default memo(LinkedConversationsPopover);
